import { render } from "./DataMapperInvocationAdmin.vue?vue&type=template&id=ad3a78ca&scoped=true"
import script from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"

import "./DataMapperInvocationAdmin.vue?vue&type=style&index=0&id=ad3a78ca&scoped=true&lang=css"
import "./DataMapperInvocationAdmin.vue?vue&type=style&index=1&id=ad3a78ca&lang=scss"
import "./DataMapperInvocationAdmin.vue?vue&type=style&index=2&id=ad3a78ca&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad3a78ca"]])

export default __exports__